/** @jsx jsx */

import { some } from 'lodash';

import { Modal } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import PartnerProfileForm, {
  PartnerProfileFormValues,
  Role,
} from 'app/developer-v3/components/PartnerProfileForm';

import TermsOnly from './TermsOnly';

type Props = {
  createPartnerProfile: (invitationData: PartnerProfileFormValues) => void;
  roles: Array<Role>;
  jobTitle: string;
  errorMessages: Array<string>;
  isSaving: boolean;
  termsAccepted: boolean;
};

const ExistingDev = ({
  createPartnerProfile,
  errorMessages,
  isSaving,
  jobTitle,
  roles,
  termsAccepted,
}: Props) => {
  return some(roles, { checked: true }) ? (
    <TermsOnly
      isSaving={isSaving}
      onConfirm={() =>
        createPartnerProfile({
          firstName: '',
          jobTitle: '',
          lastName: '',
          optIn: true,
          roles: [],
          tos: true,
        })
      }
    />
  ) : (
    <Modal canClose={false} onClosed={() => undefined}>
      <PartnerProfileForm
        errorMessages={errorMessages}
        formTitle="Zapier Platform Agreement terms have changed"
        isHeroImageVisible={false}
        isSaving={isSaving}
        jobTitle={jobTitle}
        onConfirm={createPartnerProfile}
        roles={roles}
        sections={['roles', 'title', 'tos']}
        submitText="Continue"
        termsAccepted={termsAccepted}
      />
    </Modal>
  );
};

export default ExistingDev;
